import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import ImportIcon from '@/assets/svg/bx-import.svg?react';
import { Tooltip, TooltipContent, TooltipTitle, TooltipTrigger } from '@/components/Tooltip';
import { csvDownloadRowLimit } from '@/constants';
import { numberFormat } from '@/helper/numberFormatter';

type Props = {
  downloadRowLimitReached: boolean;
};

const ExportCSVAction = ({ downloadRowLimitReached }: Props) => {
  if (downloadRowLimitReached) {
    return (
      <Tooltip>
        <TooltipTrigger
          render={
            <span className="flex items-center gap-2">
              <ImportIcon />
              <Trans>Export CSV</Trans>
            </span>
          }
        />
        <TooltipContent className="flex-col items-start">
          <TooltipTitle>{t`Record Limit`}</TooltipTitle>
          <span>{t`Export limited to ${numberFormat(csvDownloadRowLimit)} records`}</span>
        </TooltipContent>
      </Tooltip>
    );
  } else {
    return (
      <span className="flex items-center gap-2">
        <ImportIcon />
        <Trans>Export CSV</Trans>
      </span>
    );
  }
};

export default ExportCSVAction;
